export type MetricsDateRange = {
  metricsStartDay: string;
  metricsEndDay: string;
  previousMetricsStartDay: string;
  previousMetricsEndDay: string;
};

export const DEFAULT_METRICS_RANGE_DAYS = 14;

export const buildMetricsDateRange = (
  rangeDays: number = DEFAULT_METRICS_RANGE_DAYS,
): MetricsDateRange => {
  const end = new Date();
  end.setHours(23, 59, 59, 999);
  const start = new Date(end);
  start.setDate(end.getDate() - rangeDays);
  start.setHours(0, 0, 0, 0);

  const previousEnd = new Date(start);
  const previousStart = new Date(previousEnd);
  previousStart.setDate(previousEnd.getDate() - rangeDays);
  previousStart.setHours(0, 0, 0, 0);

  return {
    metricsStartDay: start.toISOString(),
    metricsEndDay: end.toISOString(),
    previousMetricsStartDay: previousStart.toISOString(),
    previousMetricsEndDay: previousEnd.toISOString(),
  };
};
